module.exports = __webpack_public_path__ + "static/media/seguradora_berkley.fa954ca3.png";